import { useState } from 'react';
import ClassNames from '@streamloots/classnames';
import { PageFeed, User } from 'model/indexTS';
import { useTranslation } from 'utils/translation';
import { PageState } from 'services/page';
import { ButtonIcon } from 'ui-library/button';
import trackEventManager from 'utils/event-manager';
import { Currency } from '@streamloots/streamloots-types';
import { currencyManager } from 'services/culture';
import { ActionWithLogin } from '../action-with-login';
import themeFooter from '../feed-list/feed-list.scss';
import { CheckoutTips } from './CheckoutTips';

const classNameFooter = ClassNames(themeFooter);

interface ButtonTipsProps {
  feed: PageFeed;
  page: PageState;
  isUserAuthenticated: boolean;
  isStaff: boolean;
  user: User | null;
}

export const ButtonTips = ({ feed, page, isUserAuthenticated, isStaff, user }: ButtonTipsProps): JSX.Element | null => {
  const { t } = useTranslation('pageFeed');
  const [showCheckout, setShowCheckout] = useState(false);

  const handleOnClose = () => {
    setShowCheckout(false);
  };

  const handleOnOpen = () => {
    setShowCheckout(true);
    trackEventManager.feedSectionViewed({
      location: 'feed content',
      section: 'tips checkout',
    });
  };

  return (
    <>
      {showCheckout && (
        <CheckoutTips onClose={handleOnClose} user={user} feed={feed} page={page} showCheckout={showCheckout} />
      )}
      <ActionWithLogin feed={feed} page={page} isAuthenticaded={isUserAuthenticated} location="feed content">
        <ButtonIcon
          iconClass={classNameFooter('feed-detail__footer__button__icon')}
          className={classNameFooter('feed-detail__footer__label-btn')}
          ariaLabel="tips"
          variant="ghost"
          icon="tips"
          disabled={
            !feed.visible && feed.restrictedTo[0] === 'PAID_CONTENT' && feed.summary.paymentStatus === 'InProgress'
          }
          label={
            isStaff || page.isOwner
              ? currencyManager.getFormattedPrice(feed.summary.tipAmount as number, page.currency as Currency)
              : t('pageFeed:tips.label')
          }
          onClick={handleOnOpen}
        />
      </ActionWithLogin>
    </>
  );
};
